import {itemsShareValue} from '../../shared/interchangeableItems';

type Question = {
  getQuestionTypeAttributes?: () => {getIn: (path: string[], fallback: unknown) => any} | undefined;
};

/**
 * Whether the item at `index` is the one the question's slot at that position calls for, or, when
 * `interchangeable`, an item that shows the same value as that answer.
 */
export const isItemCorrectAt = (
  question: Question | null | undefined,
  correctAnswer: Record<string, string> | null | undefined,
  item: {id: string; value?: unknown},
  index: number,
  interchangeable: boolean
): boolean => {
  if (!correctAnswer) return false;
  const attributes = question?.getQuestionTypeAttributes?.();
  const slots = attributes?.getIn(['ordering', 'slots'], [])?.toJS?.() ?? [];
  const slotId = slots[index]?.id;
  if (!slotId) return false;

  const correctItemId = correctAnswer[slotId];
  if (correctItemId === item.id) return true;
  if (!interchangeable) return false;

  const questionItems: {id: string; value?: unknown}[] =
    attributes?.getIn(['ordering', 'items'], [])?.toJS?.() ?? [];
  const correctItem = questionItems.find((candidate) => candidate.id === correctItemId);
  return itemsShareValue(item.value, correctItem?.value);
};
